// extracted by mini-css-extract-plugin
export default {"status":"ContactList_status__AP5wv","loaderRow":"ContactList_loaderRow__UyIYR"};